
import { parseQueryArguments } from '@/shared'
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, patchData, postData } from '../utils/db'
import { TOutTableColumn } from './outTableColumn'

export type TOutTemplate = {
  _id: string,
  name: string,
  excel: string,
  sheets: TOutTableColumn[],
}

export default class OutTemplateModel implements ITableListModel<TOutTemplate> {
  constructor() {
  }

  public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, project, page = 0, limit = 10, q = '' }: TableListRequestType) {
    if (!project) return null as never
    let query = parseQueryArguments(`page=${page}&limit=${limit}`, arguments)
    if (q) query += '&q=' + encodeURI(q)
    if (mode == TABLE_REQUEST_MODE.POSITION) {
      query += '&mode=position'
    }
    return await getData(`/projects/${project}/outtemplates?${query}`, { dbName: project })
  }

  public async read(project: string, id: string) {
    if (!project) return null as never
    return await getData(`/projects/${project}/outtemplates/${id}`)
  }

  public async create(project: string, data: any) {
    if (!project) return null as never
    return await postData(`/projects/${project}/outtemplates/`, data)
  }

  public async update(project: string, id: string, data: any) {
    if (!project) return null as never
    return await patchData(`/projects/${project}/outtemplates/${id}`, data)
  }

  public async delete(project: string, id: string) {
    if (!project) return null as never
    return await deleteData(`/projects/${project}/outtemplates/${id}`)
  }

  public async count(project: string) {
    if (!project) return null as never
    return await countData(`/projects/${project}/outtemplates/count`)
  }

  public async tableColumns(project: string, options: any = {}) {
    if (!project) return null as never
    let query = ''
    if (typeof options?.mapping !== 'undefined') {
      const mapping = options.mapping === true ? 1 : 0
      query += `mapping=${mapping}`
    }

    let url = `/projects/${project}/outtemplates/table-columns`
    if (query) url += `?${query}`

    return await getData(url)
  }

  public async tableColumn(project: string, tableId: string, options: any = {}) {
    if (!project) return null as never
    let query = ''
    if (typeof options?.mapping !== 'undefined') {
      const mapping = options.mapping === true ? 1 : 0
      query += `mapping=${mapping}`
    }

    let url = `/projects/${project}/outtemplates/table-column/${tableId}`
    if (query) url += `?${query}`

    return await getData(url)
  }

  public async checkUpload(project: string, data: any, options = {}) {
    if (!project) return null as never
    return await postData(`/projects/${project}/outtemplates/check`, data, options)
  }
}